(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4312],{

/***/ 45757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuantityControlViewed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components-v2/ui/ConsultSpecialProductBtn/index.js + 4 modules
var ConsultSpecialProductBtn = __webpack_require__(40420);
// EXTERNAL MODULE: ./src/components/organisms/RemoveProductModal/index.js
var RemoveProductModal = __webpack_require__(64325);
// EXTERNAL MODULE: ./src/hooks/useProductConsultation.js
var useProductConsultation = __webpack_require__(48699);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlViewed/styles.module.css
var styles_module = __webpack_require__(54817);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/clients/Clients.js + 1 modules
var Clients = __webpack_require__(38307);
// EXTERNAL MODULE: ./src/context/Cart/CartContext.js + 2 modules
var CartContext = __webpack_require__(15012);
// EXTERNAL MODULE: ./src/utils/debounce.js
var debounce = __webpack_require__(74118);
;// CONCATENATED MODULE: ./src/components-v2/mocules/QuantityControlViewed/useCartQuickOrder.ts






var UPDATE = "update";
var REMOVE = "remove";
var REGEX_NUMBER = new RegExp("^[0-9]+$");
function useCartQuickOrder(product, inputRef) {
    var quantityInCart = product.quantityInCart, maxQuantity = product.maxQuantity;
    var ref = (0,react.useState)(0), currentValue = ref[0], setCurrentValue = ref[1];
    var ref1 = (0,react.useState)(0), valueChange = ref1[0], setValueChange = ref1[1];
    var ref2 = (0,react.useState)(false), isShowModalRemove = ref2[0], setIsShowModalRemove = ref2[1];
    var ref3 = (0,CartContext/* useCart */.jD)(), removeCartItemQuickOrder = ref3.removeCartItemQuickOrder, updateCartItemQuickOrder = ref3.updateCartItemQuickOrder;
    var productQuantity = quantityInCart || 0;
    var updateCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(quantity) {
            var isReload, response, quantityResponse;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isReload = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        return [
                            4,
                            updateCartItemQuickOrder(+quantity, product, isReload)
                        ];
                    case 1:
                        response = _state.sent();
                        if ((0,Clients/* isValid */.JY)(response) && inputRef.current) {
                            quantityResponse = response.quantityResponse || null;
                        } else {
                            setCurrentValue(0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function updateCart(quantity) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCart = function(val, updateType) {
        switch(updateType){
            case UPDATE:
                updateCart(val);
                break;
            case REMOVE:
                removeCartItemQuickOrder(product, true);
                setValueChange(0);
                break;
            default:
                break;
        }
    };
    var handler = function(val, updateType) {
        (0,debounce/* debounceFunc400 */.EI)(function() {
            handleCart(val, updateType);
        });
    };
    var confirmRemove = function() {
        if (inputRef.current) inputRef.current.value = "0";
        setValueChange(0);
        setIsShowModalRemove(false);
        return handler(0, REMOVE);
    };
    var closeModal = function() {
        if (inputRef.current) {
            setValueChange(1);
            inputRef.current.value = String(1);
            handler(String(1), UPDATE);
        }
        setIsShowModalRemove(false);
    };
    var handleDecrease = function(e) {
        e.stopPropagation();
        if (inputRef.current) {
            var newValue = +inputRef.current.value - 1;
            if (newValue >= 0) {
                if (newValue === 0) {
                    return setIsShowModalRemove(true);
                }
                inputRef.current.value = String(newValue);
                setValueChange(newValue);
                return handler(newValue, UPDATE);
            }
            return null;
        }
        return null;
    };
    var handleIncrease = function(e) {
        e.stopPropagation();
        if (inputRef.current) {
            var newValue = +inputRef.current.value + 1;
            if (maxQuantity > 0 && newValue > maxQuantity) {
                return null;
            }
            setValueChange(newValue);
            inputRef.current.value = String(newValue);
            return handler(newValue, UPDATE);
        }
        return null;
    };
    var handleBlurInput = function(e) {
        var value = e.target.value;
        if (+value !== +currentValue) {
            if (+value && REGEX_NUMBER.test(value)) {
                return handler(value, UPDATE);
            }
        }
        if (+value === 0 && +value !== valueChange) {
            return setIsShowModalRemove(true);
        }
        return null;
    };
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (!inputRef.current) return null;
        if (value === "00") {
            inputRef.current.value = "0";
        } else if (value && value !== "0") {
            var newValue = parseInt(value, 10);
            // Check if newValue exceeds maxQuantity or 10000
            if (maxQuantity > 0 && newValue > maxQuantity || newValue > 10000) {
                newValue = maxQuantity > 0 ? maxQuantity : 10000;
            }
            // Validate input value using REGEX_NUMBER
            if (!REGEX_NUMBER.test(String(newValue))) {
                newValue = 0;
            }
            // Update the input value and state
            inputRef.current.value = String(newValue);
            setValueChange(newValue);
        } else {
            inputRef.current.value = "0";
        }
    };
    var handleFocus = function() {
        setCurrentValue(valueChange);
    };
    (0,react.useEffect)(function() {
        setCurrentValue(productQuantity);
        setValueChange(productQuantity);
        if (inputRef.current) inputRef.current.value = String(productQuantity);
    }, []);
    return [
        handleIncrease,
        handleBlurInput,
        handleChangeInput,
        handleFocus,
        handleDecrease,
        confirmRemove,
        closeModal,
        isShowModalRemove,
        valueChange
    ];
};

;// CONCATENATED MODULE: ./src/components-v2/mocules/QuantityControlViewed/index.js










function CartIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).inputVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z",
                    fill: "#999999"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z",
                    fill: "#999999"
                })
            ]
        })
    });
}
function NewIconMinus(param) {
    var handleDecrease = param.handleDecrease, currentValue = param.currentValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).minusContainerNew, "qty-control-viewed-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 12H17",
                stroke: currentValue === 0 ? "#DADADA" : "#333333",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        })
    });
}
function IconMinus(param) {
    var handleDecrease = param.handleDecrease;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleDecrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).minusContainer, "qty-control-viewed-minus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).minus
        })
    });
}
function NewIconAdd(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).addContainerNew, "qty-control-viewed-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "28",
            height: "28",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 17V7",
                    stroke: currentValue >= maxQuantityConsumed ? "#DADADA" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7 12L17 12",
                    stroke: currentValue >= maxQuantityConsumed ? "#DADADA" : "#005c29",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            ]
        })
    });
}
function IconAdd(param) {
    var handleIncrease = param.handleIncrease, currentValue = param.currentValue, maxQuantityConsumed = param.maxQuantityConsumed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleIncrease,
        className: (0,clsx/* default */.Z)((styles_module_default()).addContainer, currentValue >= maxQuantityConsumed && (styles_module_default()).disabled, "qty-control-viewed-plus"),
        role: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).addIcon
        })
    });
}
/**
 * @param {object} props
 * @param {*} props.product
 * @param {string} [props.className]
 * @param {boolean} [props.newCard]
 * @param {(e: any) => void} [props.onAdd] - callback tracking sau khi bấm nút tăng số lượng, không đổi behavior
 * @param {(e: any) => void} [props.onChange] - callback tracking sau khi nhập số lượng, không đổi behavior
 */ function QuantityControlViewed(param) {
    var product = param.product, className = param.className, newCard = param.newCard, onAdd = param.onAdd, onChange = param.onChange;
    var refValue = (0,react.useRef)(null);
    var ref = (0,_sliced_to_array/* default */.Z)(useCartQuickOrder(product, refValue), 9), handleIncrease = ref[0], handleBlurInput = ref[1], handleChangeInput = ref[2], handleFocus = ref[3], handleDecrease = ref[4], confirmRemove = ref[5], closeModal = ref[6], isShowModalRemove = ref[7], currentValue = ref[8];
    var handleCancel = function(e) {
        e.stopPropagation();
        closeModal();
    };
    // Wrapper chỉ để bắn tracking, không thay đổi behavior thêm giỏ hiện tại.
    var handleIncreaseWithTracking = function(e) {
        handleIncrease(e);
        onAdd === null || onAdd === void 0 ? void 0 : onAdd(e);
    };
    var handleChangeInputWithTracking = function(e) {
        handleChangeInput(e);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    var shouldShowConsultButton = (0,useProductConsultation/* useProductConsultation */.O)().shouldShowConsultButton;
    var handleRemove = function() {
        confirmRemove();
    };
    if (shouldShowConsultButton(product)) {
        // KHÔNG forward `className` của caller: đó là class canh chỉnh cho thanh
        // +/- (bề ngang cố định, bo góc, scale), áp lên nút tư vấn sẽ làm nút bị
        // ép width rồi tràn/lệch (dashboard truyền min-w/max-w 160px). Các biến thể
        // QuantityControl khác (Lite/Table/Cart) cũng chỉ gắn class hook riêng.
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultSpecialProductBtn/* default */.Z, {
            className: "qty-control-viewed-consult-btn",
            product: product,
            variant: ConsultSpecialProductBtn/* VARIANT_LIST.LIST_HORIZONTAL */.C.LIST_HORIZONTAL
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)((styles_module_default()).maxWidth, (product === null || product === void 0 ? void 0 : product.isHighProfit) ? "highProfitQuickOrder" : null),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)((styles_module_default()).container, className && className, "qty-control-viewed-wrapper"),
            children: [
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconMinus, {
                    currentValue: currentValue,
                    handleDecrease: handleDecrease
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMinus, {
                    handleDecrease: handleDecrease
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)((styles_module_default()).groupInput, "qty-control-viewed-input-group"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).cartIconContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIcon, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).currentValue,
                                    children: currentValue
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            className: (0,clsx/* default */.Z)((styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).newCardInput, currentValue >= (product === null || product === void 0 ? void 0 : product.maxQuantity) && ((styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).disableStyle), "qty-control-viewed-input"),
                            inputRef: refValue,
                            onBlur: handleBlurInput,
                            onChange: handleChangeInputWithTracking,
                            onFocus: handleFocus,
                            type: "number",
                            disableUnderline: true
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    className: "qty-control-viewed-input",
                    inputRef: refValue,
                    onBlur: handleBlurInput,
                    onChange: handleChangeInputWithTracking,
                    type: "number",
                    disableUnderline: true
                }),
                newCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewIconAdd, {
                    handleIncrease: handleIncreaseWithTracking,
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : product.maxQuantity
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAdd, {
                    handleIncrease: handleIncreaseWithTracking,
                    currentValue: currentValue,
                    maxQuantityConsumed: product === null || product === void 0 ? void 0 : product.maxQuantity
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveProductModal/* default */.Z, {
                    product: product,
                    visible: isShowModalRemove,
                    onClose: handleCancel,
                    onRemove: handleRemove
                })
            ]
        })
    });
};


/***/ }),

/***/ 97563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_SuggestProductBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16204);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlLite/index.js
var QuantityControlLite = __webpack_require__(74694);
// EXTERNAL MODULE: ./src/components-v2/mocules/QuantityControlViewed/index.js + 1 modules
var QuantityControlViewed = __webpack_require__(45757);
// EXTERNAL MODULE: ./src/components-v2/ui/ConsultSpecialProductBtn/index.js + 4 modules
var ConsultSpecialProductBtn = __webpack_require__(40420);
// EXTERNAL MODULE: ./src/constants/Images/index.js
var Images = __webpack_require__(13270);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/constants/SVG/index.ts
var SVG = __webpack_require__(69448);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/components-v2/mocules/CrossSellSKUCard/styles.module.css
var styles_module = __webpack_require__(10197);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/CrossSellSKUCard/index.tsx

















// BV-2271: block "Sản phẩm hay mua kèm" — clone bố cục SubstituteSKUCard, bỏ tracking/tour/Xem thêm
// (tracking làm ở BV-2273). BFF đã lọc + sort sẵn, FE chỉ render theo thứ tự nhận được.
var CrossSellSKUCard = function(param) {
    var items = param.items, _quantityVariant = param.quantityVariant, quantityVariant = _quantityVariant === void 0 ? "lite" : _quantityVariant, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)((styles_module_default()).card, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (styles_module_default()).suggestCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* QUICKORDER_SUGGEST_ICON */.wrp,
                        width: 24,
                        height: 24,
                        loading: "lazy",
                        alt: "suggest icon"
                    }),
                    "Gợi \xfd"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (0,clsx/* default */.Z)((styles_module_default()).listCard, (0,_define_property/* default */.Z)({}, (styles_module_default()).multi, items.length > 1)),
                children: items.map(function(item) {
                    var productId = item.productId, productName = item.productName, imageUrl = item.imageUrl, volume = item.volume, price = item.price, _originPrice = item.originPrice, originPrice = _originPrice === void 0 ? 0 : _originPrice, _discountPercent = item.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, _limitMessage = item.limitMessage, limitMessage = _limitMessage === void 0 ? "" : _limitMessage, sellerName = item.sellerName, sellerUrl = item.sellerUrl;
                    var linkHref = (0,Paths/* getPathProductBySlug */.hq)(item.slug);
                    // QuantityControlViewed / useCartQuickOrder đọc id / name / currentPrice / isDeal — map như SubstituteSKUCard
                    var quickOrderProduct = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        id: productId,
                        name: productName,
                        currentPrice: price,
                        isDeal: item.type === "DEAL"
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: (styles_module_default()).itemCard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (styles_module_default()).tagCard,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: Images/* QUICKORDER_CROSS_SELL_ICON */.nu1,
                                        width: 14,
                                        height: 14,
                                        loading: "lazy",
                                        alt: "cross sell icon"
                                    }),
                                    "Sản phẩm hay mua k\xe8m"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: (styles_module_default()).imageCard,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: linkHref,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                                        src: imageUrl,
                                        alt: productName,
                                        width: 88,
                                        height: 88,
                                        quality: 100,
                                        title: productName,
                                        loading: "lazy",
                                        objectFit: "contain",
                                        size: "thumbnail"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (styles_module_default()).contentCard,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: linkHref,
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (styles_module_default()).productName,
                                            children: productName
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).cardSubTitle,
                                        children: volume
                                    }),
                                    sellerName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (styles_module_default()).sellerName,
                                        href: sellerUrl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: sellerName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (styles_module_default()).priceCard,
                                children: [
                                    discountPercent > 0 && originPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        className: (styles_module_default()).priceRow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                className: (styles_module_default()).cardChip,
                                                label: "-".concat(discountPercent, "%"),
                                                size: "small"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                                displayPriceFormated: originPrice,
                                                fillPath: "#333",
                                                size: "xs",
                                                line: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        className: (styles_module_default()).priceRow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                            displayPriceFormated: price,
                                            size: "lg",
                                            textRight: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: (styles_module_default()).actionCard,
                                children: [
                                    !!limitMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).limitMessage,
                                        children: limitMessage
                                    }),
                                    quantityVariant === "quickOrder" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlViewed/* default */.Z, {
                                        className: (styles_module_default()).quantityControlQuickOrder,
                                        product: quickOrderProduct,
                                        newCard: true
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlLite/* default */.Z, {
                                        className: (styles_module_default()).quantityControlCart,
                                        product: item,
                                        newCard: true,
                                        consultVariant: ConsultSpecialProductBtn/* VARIANT_LIST.LIST_HORIZONTAL */.C.LIST_HORIZONTAL
                                    })
                                ]
                            })
                        ]
                    }, item.skuCode);
                })
            })
        ]
    });
};
/* harmony default export */ var mocules_CrossSellSKUCard = (CrossSellSKUCard);

// EXTERNAL MODULE: ./src/hooks/useSubstituteCardTracking.ts
var useSubstituteCardTracking = __webpack_require__(57901);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/types/product.ts
var product = __webpack_require__(2930);
// EXTERNAL MODULE: ./src/components-v2/mocules/SuggestProductBlock/styles.module.css
var SuggestProductBlock_styles_module = __webpack_require__(73247);
var SuggestProductBlock_styles_module_default = /*#__PURE__*/__webpack_require__.n(SuggestProductBlock_styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/SuggestProductBlock/index.tsx























// Block "Gợi ý cho bạn" gộp SPTT + SP hay mua kèm thành 1 dãy tile dọc cuộn ngang.
// Chỉ dùng khi có SP mua kèm; không có thì host vẫn render block SPTT cũ.
var SuggestProductBlock = function(_param) {
    var substitutes = _param.substitutes, crossSell = _param.crossSell, _quantityVariant = _param.quantityVariant, quantityVariant = _quantityVariant === void 0 ? "lite" : _quantityVariant, className = _param.className, id = _param.id, _flush = _param.flush, flush = _flush === void 0 ? false : _flush, mainSKU = (0,_object_without_properties/* default */.Z)(_param, [
        "substitutes",
        "crossSell",
        "quantityVariant",
        "className",
        "id",
        "flush"
    ]);
    var listRef = (0,react.useRef)(null);
    // skuReplace ở giỏ có thể là null (không chỉ undefined) nên không dựa vào default param
    var subs = substitutes || [];
    var cross = crossSell || [];
    var total = subs.length + cross.length;
    if (total === 0) return null;
    // Chỉ 1 gợi ý (1 SP mua kèm, không SPTT) thì giữ card ngang như cũ; từ 2 trở lên mới ra dãy tile.
    // Trường hợp chỉ có SPTT thì host đã tự render block SPTT cũ.
    if (total === 1 && cross.length === 1) return /*#__PURE__*/ (0,jsx_runtime.jsx)(mocules_CrossSellSKUCard, {
        className: className,
        items: cross,
        quantityVariant: quantityVariant
    });
    var scrollBy = function(dir) {
        var ref;
        return (ref = listRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
            left: dir * listRef.current.clientWidth,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).block, (0,_define_property/* default */.Z)({}, (SuggestProductBlock_styles_module_default()).flush, flush), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (SuggestProductBlock_styles_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* QUICKORDER_SUGGEST_ICON */.wrp,
                        width: 24,
                        height: 24,
                        loading: "lazy",
                        alt: "suggest icon"
                    }),
                    "Gợi \xfd cho bạn"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (SuggestProductBlock_styles_module_default()).listWrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "Cuộn tr\xe1i",
                        className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).arrow, (SuggestProductBlock_styles_module_default()).arrowLeft),
                        onClick: function() {
                            return scrollBy(-1);
                        },
                        children: "‹"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: listRef,
                        className: (SuggestProductBlock_styles_module_default()).list,
                        children: [
                            subs.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubstituteTile, (0,_object_spread/* default */.Z)({
                                    item: item,
                                    quantityVariant: quantityVariant
                                }, mainSKU), "sub-".concat(item.skuCode));
                            }),
                            cross.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
                                    item: item,
                                    variant: "crossSell",
                                    quantityVariant: quantityVariant,
                                    linkHref: (0,Paths/* getPathProductBySlug */.hq)(item.slug)
                                }, "cs-".concat(item.skuCode));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "Cuộn phải",
                        className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).arrow, (SuggestProductBlock_styles_module_default()).arrowRight),
                        onClick: function() {
                            return scrollBy(1);
                        },
                        children: "›"
                    })
                ]
            })
        ]
    });
};
// Tile SPTT: giữ nguyên tracking + style lợi nhuận cao của SubstituteSKUCard
var SubstituteTile = function(param) {
    var item = param.item, quantityVariant = param.quantityVariant, mainSKUSellerId = param.mainSKUSellerId, mainSKUProductId = param.mainSKUProductId, mainSKU = param.mainSKU, mainType = param.mainType;
    var ref = (0,useSubstituteCardTracking/* default */.Z)({
        skuReplace: item,
        mainSKUSellerId: mainSKUSellerId,
        mainSKUProductId: mainSKUProductId,
        mainSKU: mainSKU,
        mainType: mainType
    }), impressionRef = ref.impressionRef, handleDetailTracking = ref.handleDetailTracking, handleAddToCartTracking = ref.handleAddToCartTracking;
    var linkHref = (0,Paths/* getPathProductBySlug */.hq)(item.slug) + "?isSKUReplace=true&sellerIdMainSKU=".concat(mainSKUSellerId, "&productIdMainSKU=").concat(mainSKUProductId, "&mainSKU=").concat(mainSKU, "&mainType=").concat(mainType || "NORMAL");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tile, {
        item: item,
        variant: "substitute",
        quantityVariant: quantityVariant,
        linkHref: linkHref,
        impressionRef: impressionRef,
        onDetailClick: handleDetailTracking,
        onAddToCart: handleAddToCartTracking
    });
};
var Tile = function(param) {
    var item = param.item, variant = param.variant, quantityVariant = param.quantityVariant, linkHref = param.linkHref, impressionRef = param.impressionRef, onDetailClick = param.onDetailClick, onAddToCart = param.onAddToCart;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var productId = item.productId, productName = item.productName, imageUrl = item.imageUrl, volume = item.volume, price = item.price, _originPrice = item.originPrice, originPrice = _originPrice === void 0 ? 0 : _originPrice, _discountPercent = item.discountPercent, discountPercent = _discountPercent === void 0 ? 0 : _discountPercent, _limitMessage = item.limitMessage, limitMessage = _limitMessage === void 0 ? "" : _limitMessage, isHighProfit = item.isHighProfit, styleDisplay = item.styleDisplay, sellerName = item.sellerName, sellerUrl = item.sellerUrl;
    // QuantityControlViewed / useCartQuickOrder đọc id / name / currentPrice / isDeal — map như SubstituteSKUCard
    var quickOrderProduct = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        id: productId,
        name: productName,
        currentPrice: price,
        isDeal: item.type === "DEAL"
    });
    var ref12 = (0,_sliced_to_array/* default */.Z)((styleDisplay === null || styleDisplay === void 0 ? void 0 : (ref = styleDisplay.web) === null || ref === void 0 ? void 0 : (ref1 = ref.background) === null || ref1 === void 0 ? void 0 : ref1.colors) || [], 3), headColor = ref12[0], middleColor = ref12[1], endColor = ref12[2];
    var ref13 = (0,_sliced_to_array/* default */.Z)((styleDisplay === null || styleDisplay === void 0 ? void 0 : (ref2 = styleDisplay.web) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.background) === null || ref3 === void 0 ? void 0 : ref3.percentsColor) || [
        0,
        0.5,
        1
    ], 3), headPercentColor = ref13[0], middlePercentColor = ref13[1], endPercentColor = ref13[2];
    var angle = (styleDisplay === null || styleDisplay === void 0 ? void 0 : (ref4 = styleDisplay.web) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.background) === null || ref5 === void 0 ? void 0 : ref5.angle) || 180;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: impressionRef,
        className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).tile, (0,_define_property/* default */.Z)({}, "highProfitDoubleLayer", isHighProfit && (styleDisplay === null || styleDisplay === void 0 ? void 0 : (ref6 = styleDisplay.web) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.background) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.length) === product/* EnumHighProfitLayer.DOUBLE_LAYER */.w5.DOUBLE_LAYER), (0,_define_property/* default */.Z)({}, "highProfitTribleLayer", isHighProfit && (styleDisplay === null || styleDisplay === void 0 ? void 0 : (ref9 = styleDisplay.web) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.background) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.colors) === null || ref11 === void 0 ? void 0 : ref11.length) === product/* EnumHighProfitLayer.TRIBLE_LAYER */.w5.TRIBLE_LAYER)),
        style: {
            "--high-profit-head-color": headColor !== null && headColor !== void 0 ? headColor : undefined,
            "--high-profit-middle-color": middleColor !== null && middleColor !== void 0 ? middleColor : undefined,
            "--high-profit-end-color": endColor !== null && endColor !== void 0 ? endColor : undefined,
            "--high-profit-angle": angle ? "".concat(angle, "deg") : undefined,
            "--high-profit-head-percent-color": headPercentColor !== undefined ? "".concat(headPercentColor * 100, "%") : undefined,
            "--high-profit-middle-percent-color": middlePercentColor !== undefined ? "".concat(middlePercentColor * 100, "%") : undefined,
            "--high-profit-end-percent-color": endPercentColor !== undefined ? "".concat(endPercentColor * 100, "%") : undefined
        },
        children: [
            variant === "substitute" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).tag, (SuggestProductBlock_styles_module_default()).tagSubstitute),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* QUICKORDER_REPLACE_ICON */.PO5,
                        width: 14,
                        height: 14,
                        loading: "lazy",
                        alt: "replace icon"
                    }),
                    "Sản phẩm thay thế"
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: (0,clsx/* default */.Z)((SuggestProductBlock_styles_module_default()).tag, (SuggestProductBlock_styles_module_default()).tagCrossSell),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Images/* QUICKORDER_CROSS_SELL_ICON */.nu1,
                        width: 14,
                        height: 14,
                        loading: "lazy",
                        alt: "cross sell icon"
                    }),
                    "Sản phẩm mua k\xe8m"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: (SuggestProductBlock_styles_module_default()).image,
                onClick: onDetailClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: linkHref,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* ImageFallbackProductImage */.nZ, {
                        src: imageUrl,
                        alt: productName,
                        width: 96,
                        height: 96,
                        quality: 100,
                        title: productName,
                        loading: "lazy",
                        objectFit: "contain",
                        size: "thumbnail"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (SuggestProductBlock_styles_module_default()).priceRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                        displayPriceFormated: price,
                        size: "md"
                    }),
                    discountPercent > 0 && originPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* SVGPrice */.X, {
                                displayPriceFormated: originPrice,
                                fillPath: "#333",
                                size: "xs",
                                line: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                className: (SuggestProductBlock_styles_module_default()).chip,
                                label: "-".concat(discountPercent, "%"),
                                size: "small"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkHref,
                prefetch: false,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (SuggestProductBlock_styles_module_default()).name,
                    onClick: onDetailClick,
                    children: productName
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (SuggestProductBlock_styles_module_default()).volume,
                children: volume
            }),
            sellerName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (SuggestProductBlock_styles_module_default()).seller,
                href: sellerUrl,
                target: "_blank",
                rel: "noreferrer",
                children: sellerName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: (SuggestProductBlock_styles_module_default()).action,
                children: [
                    !!limitMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (SuggestProductBlock_styles_module_default()).limit,
                        children: limitMessage
                    }),
                    quantityVariant === "quickOrder" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlViewed/* default */.Z, {
                        className: (SuggestProductBlock_styles_module_default()).quantityControlQuickOrder,
                        product: quickOrderProduct,
                        newCard: true,
                        onAdd: onAddToCart,
                        onChange: onAddToCart
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityControlLite/* default */.Z, {
                        className: (SuggestProductBlock_styles_module_default()).quantityControlCart,
                        product: item,
                        newCard: true,
                        consultVariant: ConsultSpecialProductBtn/* VARIANT_LIST.LIST_HORIZONTAL */.C.LIST_HORIZONTAL,
                        onAdd: onAddToCart,
                        onChange: onAddToCart
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mocules_SuggestProductBlock = (SuggestProductBlock);


/***/ }),

/***/ 95863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_TourIntro; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/components-v2/mocules/BorderLinearProgress/index.js
var BorderLinearProgress = __webpack_require__(22731);
// EXTERNAL MODULE: ./src/components-v2/mocules/TourIntro/styles.module.css
var styles_module = __webpack_require__(61941);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components-v2/mocules/TourIntro/ProgressTour/index.js




var ProgressTour = function(param) {
    var handleCallBack = param.handleCallBack, stepActive = param.stepActive, tourStep = param.tourStep, _width = param.width, width = _width === void 0 ? 310 : _width;
    var ref = (0,react.useState)(30), progress = ref[0], setProgress = ref[1];
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            setProgress(function(oldProgress) {
                if (oldProgress >= 100) {
                    handleCallBack();
                    return 0;
                }
                return oldProgress + 1;
            });
        }, 300);
        return function() {
            clearInterval(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        setProgress(0);
    }, [
        stepActive
    ]);
    if (tourStep.length === 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).linerProgress,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress/* default */.Z, {
                variant: "determinate",
                value: progress,
                width: width,
                height: 8,
                bgcolor: "#D9D9D9",
                bgliner: "#fff",
                linerradius: 0,
                radius: 0
            })
        })
    });
};
/* harmony default export */ var TourIntro_ProgressTour = (ProgressTour);

;// CONCATENATED MODULE: ./src/components-v2/mocules/TourIntro/index.js








var objStyle = {
    right: (styles_module_default()).right,
    left: (styles_module_default()).left,
    top: (styles_module_default()).top,
    "top-sticky": (styles_module_default()).topSticky,
    bottom: (styles_module_default()).bottom
};
var TourIntro = function(param) {
    var _steps = param.steps, steps = _steps === void 0 ? [] : _steps, _defaultStep = param.defaultStep, defaultStep = _defaultStep === void 0 ? 0 : _defaultStep, _isReady = param.isReady, isReady = _isReady === void 0 ? false : _isReady, onFinish = param.onFinish, name = param.name, _isHiddenScroll = param.isHiddenScroll, isHiddenScroll = _isHiddenScroll === void 0 ? false : _isHiddenScroll, _isShowUnderStand = param.isShowUnderStand, isShowUnderStand = _isShowUnderStand === void 0 ? false : _isShowUnderStand;
    var ref, ref1;
    var stepState = ((ref = JSON.parse(localStorage.getItem(name))) === null || ref === void 0 ? void 0 : ref.stepsFinish) || [];
    var ref2 = (0,react.useState)(defaultStep), stepActive = ref2[0], setStepActive = ref2[1];
    var ref3 = (0,react.useState)({}), styleInline = ref3[0], setStyleInline = ref3[1];
    var ref4 = (0,react.useState)({}), styleInlineArrow = ref4[0], setStyleInlineArrow = ref4[1];
    var ref5 = (0,react.useState)(310), widthProgress = ref5[0], setWidthProgress = ref5[1];
    // back not show timelapse
    // const [isShowTimeLine, setIsShowTimeLine] = useState(true);
    var ref6 = (0,react.useState)([]), tourStep = ref6[0], setTourStep = ref6[1];
    var refTooltip = (0,react.useRef)();
    var intervalRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if ((stepState === null || stepState === void 0 ? void 0 : stepState.length) > 0) {
            var revertStep = (stepState === null || stepState === void 0 ? void 0 : stepState.length) > 0 ? steps.filter(function(x) {
                return (x === null || x === void 0 ? void 0 : x.refCurrent.current) && !(stepState === null || stepState === void 0 ? void 0 : stepState.some(function(data) {
                    return data === (x === null || x === void 0 ? void 0 : x.name);
                }));
            }) : steps.filter(function(x) {
                return x === null || x === void 0 ? void 0 : x.refCurrent.current;
            });
            setTourStep(function() {
                return revertStep;
            });
        } else {
            setTourStep(function() {
                var revertStep = steps.filter(function(x) {
                    return x === null || x === void 0 ? void 0 : x.refCurrent.current;
                });
                return revertStep;
            });
        }
    }, [
        steps
    ]);
    var scrollTo = function(refCurrent, position) {
        var typeBock = {
            bottom: "center",
            top: "end",
            left: "center",
            right: "center"
        };
        refCurrent.scrollIntoView({
            behavior: "smooth",
            block: typeBock[position]
        });
    };
    var magicTour = function(step) {
        var ref;
        if (step > tourStep.length - 1) {
            return null;
        }
        var getStep = tourStep[step];
        var refInstance = getStep === null || getStep === void 0 ? void 0 : (ref = getStep.refCurrent) === null || ref === void 0 ? void 0 : ref.current;
        if (getStep && refInstance) {
            setWidthProgress(function(defaultValue) {
                var ref;
                return (getStep === null || getStep === void 0 ? void 0 : (ref = getStep.styles) === null || ref === void 0 ? void 0 : ref.width) || defaultValue;
            });
            refTooltip.current.classList.add((styles_module_default()).animationToolTip);
            refInstance.classList.add((styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).activeTour);
            scrollTo(refInstance, getStep.position);
            refInstance.appendChild(refTooltip.current);
            setStyleInline(function() {
                return getStep === null || getStep === void 0 ? void 0 : getStep.styles;
            });
            setStyleInlineArrow(function() {
                return getStep === null || getStep === void 0 ? void 0 : getStep.stylesArrow;
            });
        } else {
            setStepActive(function(prev) {
                return prev + 1;
            });
            magicTour(step + 1);
        }
        return null;
    };
    var removeMagicTour = function(step) {
        var ref;
        var refInstance = (ref = tourStep[step]) === null || ref === void 0 ? void 0 : ref.refCurrent;
        refInstance.current.classList.remove((styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default()).activeTour);
        refInstance.current.removeChild(refTooltip.current);
    };
    var handleNext = function() {
        if (stepActive === tourStep.length - 1) {
            clearInterval(intervalRef.current);
            var hasViewedAllSteps = tourStep.length === steps.length;
            if (hasViewedAllSteps) {
                localStorage.setItem(name, JSON.stringify({
                    isFinish: true
                }));
            } else {
                var stepsFinish = tourStep.map(function(step) {
                    return step === null || step === void 0 ? void 0 : step.name;
                });
                hasViewedAllSteps = (stepsFinish === null || stepsFinish === void 0 ? void 0 : stepsFinish.length) + (stepState === null || stepState === void 0 ? void 0 : stepState.length) === steps.length;
                localStorage.setItem(name, JSON.stringify({
                    isFinish: hasViewedAllSteps,
                    stepsFinish: (0,_to_consumable_array/* default */.Z)(stepState || []).concat((0,_to_consumable_array/* default */.Z)(stepsFinish))
                }));
            }
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            onFinish(hasViewedAllSteps);
            removeMagicTour(stepActive);
        } else {
            setStepActive(function(prev) {
                removeMagicTour(prev);
                magicTour(prev + 1);
                return prev + 1;
            });
        }
    };
    var handleBack = function(e) {
        // set hidden timelap
        // setIsShowTimeLine(false);
        e.preventDefault();
        e.stopPropagation();
        setStepActive(function(prev) {
            removeMagicTour(prev);
            magicTour(prev - 1);
            return prev - 1;
        });
    };
    var onCallBack = function() {
        setStepActive(function(prev) {
            removeMagicTour(prev);
            magicTour(prev + 1);
            return prev + 1;
        });
    };
    (0,react.useEffect)(function() {
        if (isReady) {
            magicTour(defaultStep);
        }
    }, [
        isReady,
        tourStep
    ]);
    (0,react.useEffect)(function() {
        if (isHiddenScroll) {
            var timOut = setTimeout(function() {
                document.body.style.overflow = "hidden";
            }, 0);
            return function() {
                return clearTimeout(timOut);
            };
        }
    }, [
        isHiddenScroll
    ]);
    if (!isReady || tourStep.length === 0) return null;
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).portalContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)(objStyle[(ref1 = tourStep[stepActive]) === null || ref1 === void 0 ? void 0 : ref1.position]),
            style: styleInline,
            ref: refTooltip,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (styles_module_default()).modal,
                    children: tourStep[stepActive].context
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).footer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).stepActive,
                            children: (tourStep === null || tourStep === void 0 ? void 0 : tourStep.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    stepActive + 1,
                                    "/",
                                    tourStep === null || tourStep === void 0 ? void 0 : tourStep.length
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).groupButton,
                            children: [
                                stepActive === 0 && isShowUnderStand && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    className: (styles_module_default()).back,
                                    onClick: function() {
                                        onFinish();
                                        removeMagicTour(stepActive);
                                    },
                                    children: "T\xf4i đ\xe3 hiểu"
                                }),
                                stepActive > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    className: (styles_module_default()).back,
                                    onClick: handleBack,
                                    children: "Quay lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                    className: (styles_module_default()).next,
                                    onClick: handleNext,
                                    children: stepActive === tourStep.length - 1 ? "Đ\xe3 hiểu" : "Tiếp theo"
                                })
                            ]
                        })
                    ]
                }),
                tourStep.length - 1 !== stepActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(TourIntro_ProgressTour, {
                    handleCallBack: onCallBack,
                    stepActive: stepActive,
                    tourStep: tourStep,
                    width: widthProgress
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).arrow,
                    style: styleInlineArrow
                })
            ]
        })
    }), document.body);
};
/* harmony default export */ var mocules_TourIntro = (TourIntro);


/***/ }),

/***/ 64325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _RemoveProductModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70000);


/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(_RemoveProductModal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 57901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSubstituteCardTracking; }
/* harmony export */ });
/* harmony import */ var context_Auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95581);
/* harmony import */ var hooks_useOnceInViewport__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29720);
/* harmony import */ var hooks_useTrackingMonitorHighMargin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30086);
/* harmony import */ var hooks_useTrackingMonitorSubstituteProduct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9358);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_gtag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57059);
/* harmony import */ var utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2288);







// Tracking của card SPTT (impression, click chi tiết, Xem thêm, add to cart + lợi nhuận cao).
// Tách khỏi SubstituteSKUCard để tile SPTT trong block "Gợi ý cho bạn" (SuggestProductBlock) dùng chung.
function useSubstituteCardTracking(param) {
    var skuReplace = param.skuReplace, mainSKUSellerId = param.mainSKUSellerId, mainSKUProductId = param.mainSKUProductId, mainSKU = param.mainSKU, mainType = param.mainType;
    var productId = skuReplace.productId, sellerId = skuReplace.sellerId, skuCode = skuReplace.skuCode, errorCode = skuReplace.errorCode, isHighProfit = skuReplace.isHighProfit;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var user = (0,context_Auth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)().user;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,hooks_useTrackingMonitorSubstituteProduct__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), trackingMonitorSubstituteClickMore = ref.trackingMonitorSubstituteClickMore, trackingMonitorSubstituteClickDetail = ref.trackingMonitorSubstituteClickDetail, trackingMonitorSubstituteMainSKUImpression = ref.trackingMonitorSubstituteMainSKUImpression, trackingMonitorSubstituteAddToCart = ref.trackingMonitorSubstituteAddToCart;
    var ref1 = (0,hooks_useTrackingMonitorHighMargin__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), trackingHighMarginImpression = ref1.trackingHighMarginImpression, trackingHighMarginClickDetail = ref1.trackingHighMarginClickDetail, trackingHighMarginAddToCart = ref1.trackingHighMarginAddToCart;
    var gtagPayload = function() {
        return {
            screen: (0,utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* .mapPathToCategory */ .GH)(window.location.pathname),
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            sku: skuCode,
            sellerId: sellerId,
            productId: productId,
            resultPage: (0,utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getResultPage */ .Sq)(router),
            mainSkuStatus: (0,utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__/* .mapMainSkuStatus */ .xl)(mainType)
        };
    };
    var monitorPayload = function() {
        return {
            sku: skuCode,
            sellerId: (sellerId === null || sellerId === void 0 ? void 0 : sellerId.toString()) || "",
            sellerCode: "",
            productId: (productId === null || productId === void 0 ? void 0 : productId.toString()) || "",
            type: errorCode || "Instock",
            pathname: router.pathname,
            resultPage: (0,utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getResultPage */ .Sq)(router),
            sellerIdMainSKU: (mainSKUSellerId === null || mainSKUSellerId === void 0 ? void 0 : mainSKUSellerId.toString()) || "",
            productIdMainSKU: mainSKUProductId || "",
            mainSKU: mainSKU || "",
            mainType: mainType || "NORMAL"
        };
    };
    var highMarginGtagPayload = function() {
        return {
            customerId: user === null || user === void 0 ? void 0 : user.customerID,
            screen: (0,utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* .mapPathToCategory */ .GH)(window.location.pathname),
            resultPage: (0,utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getResultPage */ .Sq)(router),
            sku: skuCode,
            sellerId: sellerId,
            productId: productId
        };
    };
    var highMarginMonitorPayload = function() {
        return {
            sku: skuCode,
            sellerId: (sellerId === null || sellerId === void 0 ? void 0 : sellerId.toString()) || "",
            productId: (productId === null || productId === void 0 ? void 0 : productId.toString()) || "",
            pathname: router.pathname,
            resultPage: (0,utils_TrackingHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getResultPage */ .Sq)(router)
        };
    };
    var handleDetailTracking = function() {
        utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].substituteClickDetail */ .ZP.substituteClickDetail(gtagPayload());
        trackingMonitorSubstituteClickDetail(monitorPayload());
        if (isHighProfit) {
            utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].highMarginClickDetail */ .ZP.highMarginClickDetail(highMarginGtagPayload());
            trackingHighMarginClickDetail(highMarginMonitorPayload());
        }
    };
    var handleShowMoreTracking = function() {
        utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].substituteClickMore */ .ZP.substituteClickMore(gtagPayload());
        trackingMonitorSubstituteClickMore(monitorPayload());
    };
    // Event "Add substitute product to cart": bắn khi bấm Add to Cart / nhập số lượng trên card (BV-1669)
    var handleAddToCartTracking = function() {
        utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].substituteClickAddToCart */ .ZP.substituteClickAddToCart(gtagPayload());
        trackingMonitorSubstituteAddToCart(monitorPayload());
        if (isHighProfit) {
            utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].highMarginAddToCart */ .ZP.highMarginAddToCart(highMarginGtagPayload());
            trackingHighMarginAddToCart(highMarginMonitorPayload());
        }
    };
    // Event "Search result having substitute product impression": 1 lần khi card hiện >= 50% viewport (spec MKT)
    var impressionRef = (0,hooks_useOnceInViewport__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].substituteSearchResult */ .ZP.substituteSearchResult(gtagPayload());
        trackingMonitorSubstituteMainSKUImpression(monitorPayload());
        if (isHighProfit) {
            utils_gtag__WEBPACK_IMPORTED_MODULE_5__/* ["default"].highMarginImpression */ .ZP.highMarginImpression(highMarginGtagPayload());
            trackingHighMarginImpression(highMarginMonitorPayload());
        }
    }, 0.5);
    return {
        impressionRef: impressionRef,
        handleDetailTracking: handleDetailTracking,
        handleShowMoreTracking: handleShowMoreTracking,
        handleAddToCartTracking: handleAddToCartTracking
    };
};


/***/ }),

/***/ 10197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__nAxz1","suggestCard":"styles_suggestCard__L4xil","listCard":"styles_listCard__8tYPc","itemCard":"styles_itemCard__U7Amd","multi":"styles_multi__dm6Xm","tagCard":"styles_tagCard__VPnC2","imageCard":"styles_imageCard__FXY8w","image":"styles_image__TBQwK","contentCard":"styles_contentCard__bjEzF","productName":"styles_productName__WPlEo","cardSubTitle":"styles_cardSubTitle__82Z7I","sellerName":"styles_sellerName__oM0S6","priceCard":"styles_priceCard__b314_","priceRow":"styles_priceRow__kniGM","cardChip":"styles_cardChip__DCgS_","actionCard":"styles_actionCard__hz8pz","limitMessage":"styles_limitMessage__eVlm2","quantityControlQuickOrder":"styles_quantityControlQuickOrder__Zbool","quantityControlCart":"styles_quantityControlCart__hPetc"};

/***/ }),

/***/ 54817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___oLk_","minusContainer":"styles_minusContainer__dNp6u","minus":"styles_minus__MIxu_","addContainerNew":"styles_addContainerNew__v_8_6","minusContainerNew":"styles_minusContainerNew__flGSc","count":"styles_count__w3HoS","addContainer":"styles_addContainer__kb4hZ","addIcon":"styles_addIcon__mVGfP","disabled":"styles_disabled__XQ_cS","newCardInput":"styles_newCardInput__hecWu","maxWidth":"styles_maxWidth__qS6it","groupInput":"styles_groupInput__H1lLR","cartIconContainer":"styles_cartIconContainer__FoKUV","inputVisible":"styles_inputVisible__m_CzR","currentValue":"styles_currentValue__b2ijJ","disableStyle":"styles_disableStyle__Q2Jre"};

/***/ }),

/***/ 73247:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"styles_block__Lvl3K","flush":"styles_flush__d0iSc","list":"styles_list____YFr","header":"styles_header__DL0Lw","listWrap":"styles_listWrap__eaVXF","tile":"styles_tile__xLG1u","tag":"styles_tag__Sgcul","tagSubstitute":"styles_tagSubstitute__iwzWa","tagCrossSell":"styles_tagCrossSell__VnutV","image":"styles_image__JDvHV","priceRow":"styles_priceRow__D2xVN","chip":"styles_chip__Vzc47","name":"styles_name__lQUZc","volume":"styles_volume__1Nk2z","seller":"styles_seller__mgJ57","action":"styles_action__LAmnV","limit":"styles_limit__I1DJ4","quantityControlQuickOrder":"styles_quantityControlQuickOrder__d0owQ","quantityControlCart":"styles_quantityControlCart__dvAbQ","arrow":"styles_arrow__z5ZZ6","arrowLeft":"styles_arrowLeft__bhZF5","arrowRight":"styles_arrowRight__uMLgS"};

/***/ }),

/***/ 61941:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"portalContainer":"styles_portalContainer__uu6eI","activeTour":"styles_activeTour__ZXZM3","beautiful":"styles_beautiful__GyZzX","right":"styles_right__ifCAI","left":"styles_left__LqZRN","top":"styles_top__NSSG4","bottom":"styles_bottom__o5und","topSticky":"styles_topSticky__NM5_W","animationToolTip":"styles_animationToolTip__VbFjB","fadeIn":"styles_fadeIn__1JccD","arrow":"styles_arrow__yBXS8","back":"styles_back__XEKoT","next":"styles_next__CjiE_","groupButton":"styles_groupButton__WvfAD","closeButton":"styles_closeButton__uRN4F","closeText":"styles_closeText__HfNSq","footer":"styles_footer__gVmEo","stepActive":"styles_stepActive__d3fLP","linerProgress":"styles_linerProgress__ccoQ_","wrapper":"styles_wrapper__PdYwL","modal":"styles_modal__xBAZH"};

/***/ })

}]);